<template>
    <div class="classroom-ended-sales light">
        <div>
            <p class="for-parents">For Grown-ups</p>
            <h2>Loved your coding lesson?</h2>

            <p>
                Your child can come back every week to learn new skills, make friends, and get even better at
                coding.
                Each
                coding lesson is designed to be exciting, creative, and confidence-boosting.
            </p>

            <div class="icon-section">
                <img class="icon" :src="rocket" alt="" />
                <div>
                    <h3>Build a new game every 4 weeks</h3>

                    <p>
                        Our curriculum is built around fun projects. Every four weeks, students create a brand-new
                        game - from concept to play-testing. It keeps learning fresh and helps kids see real progress
                        fast.
                    </p>
                </div>
            </div>


            <div class="icon-section">
                <img class="icon" :src="pause" alt="" />
                <div>
                    <h3>Flexible for families</h3>
                    <p>
                        Life gets busy! You can pause or cancel your subscription at any time.
                        No commitments. No stress. Just learning that fits your schedule.
                    </p>
                </div>
            </div>

            <div class="icon-section">
                <img class="icon" :src="discount" alt="" />
                <div>
                    <h3>50% off your first 4 weeks!</h3>
                    <p>
                        If you sign up today, you'll get half-price lessons for your first four weeks. It's the
                        perfect
                        way to keep the momentum going after the trial lesson.
                    </p>
                </div>
            </div>
            <div class="icon-section" style="display: flex; flex-direction: column; text-align: center;">
                <h3>Don't miss the {{ cohortMonth }} cohort!</h3>
                <div>
                    <div class="button" @click="onSignUpClick">
                        Sign up now
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>

import { computed, onMounted, ref } from "vue";
import discount from "@/assets/icons/discount.png";
import rocket from "@/assets/icons/rocket.png";
import pause from "@/assets/icons/pause.png";

const props = defineProps({
    denied: Boolean,
    teacherUuid: String,
    studentUuid: String,
    lessonUuid: String,
    showJourney: Boolean,
    theme: String
});

function onSignUpClick() {
    document.location.href = 'https://www.cococoders.com/book/';
}

const cohortMonth = computed(() => {
    const date = new Date();
    const day = date.getDate();
    const month = date.getMonth(); // 0–11
    const year = date.getFullYear();

    // If day is > 15 → current month
    // Else → next month (may be next year)
    const targetMonth = day < 15 ? month : (month + 1) % 12;
    const targetYear = day < 15 ? year : (month === 11 ? year + 1 : year);

    return new Date(targetYear, targetMonth, 1)
        .toLocaleString('en-US', { month: 'long' });
});

</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';


.for-parents {
    text-transform: uppercase;
    margin: 20px 0;
    font-size: 90%;
    color: $indigo
}

.classroom-ended-sales {
    color: $indigo;
    background-color: $lighterIndigo;
    width: 100%;
    padding-bottom: 50px;

    .icon-section {
        display: flex;
        padding-top: 30px;
    }

    .icon {
        width: 60px;
        height: 60px;
        margin-right: 20px
    }

    >div {
        max-width: 600px;
        margin: 0 auto;
        text-align: left;
        padding: 40px 40px;
    }

    h2 {
        color: $indigo;
        margin-bottom: 15px;
    }

    h3 {
        color: $indigo;
        margin-bottom: 5px;
    }
}
</style>
